import React from 'react';
import bemify from 'bemify-js';

import { StaticImage } from '@zapier/common-components';

import './NextSteps.scss';
import Confetti from '../components/Confetti';
import Paragraph from '../components/Paragraph';
import StepTitle from '../components/StepTitle';

const bem = bemify('next-steps');

const NextStepsSetup = () => (
  <div className={bem()}>
    <div className={bem('__hero')}>
      <StaticImage
        alt="next-steps-emoji"
        className={bem('__image')}
        src="https://cdn.zapier.com/zapier/images/developer-guide/next-steps-emoji.svg"
        title="Smiling face"
      />
      <Confetti />
      <StepTitle>Congrats! You set up your environment.</StepTitle>
    </div>
    <Paragraph>
      You've just set up your Zapier development environment! Next, you will
      create an example app, run your first automated test, and deploy your app
      to the Zapier platform.
    </Paragraph>
  </div>
);

export default NextStepsSetup;
